import React from 'react';
import Typography from '../Text/Typography';
import Icon from '../Icon/Icon';
import Tag from '../Tag/Tag';
import IconButton from '../Button/IconButton';
import Banner from '../Banner/Banner';
import { getActionIcon } from '../../utils/actions';
import './ActionRoutineCard.css';

interface ActionRoutineCardProps {
  actionId: string;
  actionName: string;
  description: string;
  onDelete?: () => void;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
  showMobileControls?: boolean;
  showOrderWarning?: boolean;
  expectedPosition?: number;
  currentPosition?: number;
}

const ActionRoutineCard: React.FC<ActionRoutineCardProps> = ({
  actionId,
  actionName,
  description,
  onDelete,
  onDragStart,
  onDragEnd,
  onMoveUp,
  onMoveDown,
  canMoveUp = true,
  canMoveDown = true,
  showMobileControls = false,
  showOrderWarning = false,
  expectedPosition,
  currentPosition
}) => {


  return (
    <div 
      className="action-routine-card"
      draggable={!!onDragStart}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      {/* Main content row */}
      <div className="action-routine-card-main">
        {/* Drag Handle */}
        <div className="action-routine-card-drag-handle">
          <Icon name="drag" size="large" />
        </div>

        {/* Action Icon */}
        <div className="action-routine-card-icon">
          <div className="action-routine-card-icon-container">
            <Icon name={getActionIcon(actionId)} size="large" />
          </div>
        </div>

        {/* Content Area */}
        <div className="action-routine-card-content">
          <div className="action-routine-card-texts">
            <Typography variant="body-small-bold" className="action-routine-card-type">
              Action
            </Typography>
            <Typography variant="body-bold" className="action-routine-card-name">
              {actionName}
            </Typography>
            <Typography variant="body-small" className="action-routine-card-description">
              {description}
            </Typography>
          </div>
          
          <Tag>Action</Tag>
        </div>

        {/* Mobile Reordering Controls */}
        {showMobileControls && (
          <div className="action-routine-card-mobile-controls">
            <IconButton
              icon={<Icon name="chevron-up" size="small" />}
              onClick={onMoveUp}
              disabled={!canMoveUp}
              ariaLabel="Move up"
              className="mobile-reorder-button"
            />
            <IconButton
              icon={<Icon name="chevron-down" size="small" />}
              onClick={onMoveDown}
              disabled={!canMoveDown}
              ariaLabel="Move down"
              className="mobile-reorder-button"
            />
          </div>
        )}

        {/* Delete Icon Button */}
        {onDelete && (
          <IconButton
            icon={<Icon name="trash" size="large" />}
            onClick={onDelete}
            ariaLabel="Delete action"
          />
        )}
      </div>

      {/* Order Warning Banner - positioned below main content */}
      {showOrderWarning && (
        <div className="action-routine-card-order-warning">
          <Banner variant="caution" title="Order Warning">
            This action should be used in position {expectedPosition} for optimal results.
          </Banner>
        </div>
      )}
    </div>
  );
};

export default ActionRoutineCard;
